import React, { Component } from "react";
import { compose } from "redux";
import { bool, string, shape } from "prop-types";
import classNames from "classnames";

import withFocus from "pages/_components/withFocus";
import { resizableRoute } from "pages/_components/Resizable";
import FieldError from "pages/_components/fields/FieldError";

class Title extends Component {
    static propTypes = {
        bold: bool,
        text: string.isRequired,
        form: shape({
            errors: shape({}),
            touched: bool,
        }).isRequired,
        field: shape({
            name: string,
        }).isRequired,
        isFocused: bool,
    };

    static defaultProps = {
        bold: false,
        isFocused: false,
    };

    render() {
        const {
            bold,
            text,
            form: { errors, touched },
            field,
            isFocused,
        } = this.props;
        const hasError = touched[field.name] && errors[field.name];

        return (
            <div
                className={classNames("form-group", {
                    "has-error": hasError,
                    "has-focus": isFocused,
                })}>
                <div className={`${bold ? "font-bold" : ""}`}>{text}</div>

                {hasError && <FieldError error={errors[field.name]} />}
            </div>
        );
    }
}
export default compose(resizableRoute, withFocus)(Title);
